import PropTypes from 'prop-types'
import React, {createContext} from 'react'

export const TransformPropTypes = PropTypes.shape({
  blur: PropTypes.number,
  progressive: PropTypes.bool,
  width: PropTypes.number,
  mobile: PropTypes.bool,
  format: PropTypes.oneOf(['webp']),
})

export const PictureContext = createContext({
  defaults: {},
  overwrites: {},
})

export const PictureContextProvider = ({defaults, overwrites, children}) => (
  <PictureContext.Provider value={{defaults, overwrites}}>{children}</PictureContext.Provider>
)

PictureContextProvider.propTypes = {
  defaults: TransformPropTypes,
  overwrites: TransformPropTypes,
  children: PropTypes.node.isRequired,
}

PictureContextProvider.defaultProps = {
  defaults: {},
  overwrites: {},
}
